module.exports = __webpack_public_path__ + "img/5.e8fd59e0.png";